<template>
  <template-info :bgImg="bgImg" title="บุคคลธรรมดากับนิติบุคคล">
    <div>
      <div class="content-title">
        <span class="bold">บุคคลธรรมดา</span> ในทางกฎหมายบุคคลธรรมดารวมถึง
        คณะบุคคลที่ประกอบธุรกิจ และห้างหุ้นส่วนสามัญ ไม่จดทะเบียน
      </div>
      <div class="content-title">
        <span class="bold">นิติบุคคล</span> หมายถึง
        กลุ่มบุคคลที่รวมตัวกันและไปจด ทะเบียนกับกรมพัฒนาธุรกิจการค้า
        กระทรวงพาณิชย์ รูปแบบที่เราคุ้นเคยกันก็คือ บริษัทจำกัด หรือ
        ห้างหุ้นส่วนจำกัด
      </div>
      <external-link
        @clickLink="gotoInfoBusiness"
        caption="เริ่มทำธุรกิจแบบไหนอุ่นใจกว่า"
        class="link-desktop"
        style="margin-top: 20px;"
      />
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/person_type_definition.png";

export default {
  name: "PersonTypeDefinition",
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    gotoInfoBusiness() {
      window.open(
        "https://www.rd.go.th/publish/fileadmin/user_upload/SMEs/infographic/8_infobusiness63.pdf",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.content-title {
  margin-bottom: 20px;
}
.bold {
  font-weight: bold;
}
</style>
